import Vue from "vue";
import Toast from "vue-toastification";
// Import the CSS or use your own!
// import "vue-toastification/dist/index.css";
import "@/assets/Global/scss/toast.scss"



const options = {
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
  
};


Vue.use(Toast, options);